<app-loading *ngIf="loading"></app-loading>
<div class="panel-header panel-header-sm">
    <div class="row link-header ml-5">
        <div>
            <a class="a-home" routerLink="/home">Home/</a>
        </div>
        <div>
            <a class="a-return" routerLink="/reprint">Reimpresion/</a>
        </div>
        <div>
            <a class="text-info" routerLink="/reprint-shipment-massive">Descarga Masiva Remisiones</a>
        </div>
    </div>
</div>
<br />
<div class="main-content">
    <!-- FILTRO DE FECHAS -->
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <b style="font-size: 1rem;">{{storeName}}</b>
                        </div>
                        <div class="col-md-4">
                            <label>Del:</label>
                            <div class="form-group">
                                <input type="date" class="form-control" [(ngModel)]="begDate" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label>Para:</label>
                            <div class="form-group">
                                <input type="date" class="form-control" [(ngModel)]="endDate" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <br>
                            <div class="form-group">
                                <button class="btn btn-info btn-sale" style="width: 100%;" [disabled]="isDisabled"
                                    (click)="getAll()">Aceptar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- FIN FILTRO -->

    <!-- TABLA -->
    <div class="row" *ngIf="isReprint">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col-md-4">
                            <button class="btn btn-success btn-sale" style="width: 100%;"
                                (click)="downloadMassive()" [disabled]="isDisabled">
                                Descargar Masivo PDF
                            </button>
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-warning btn-sale" style="width: 100%;"
                                (click)="downloadToExcel()" [disabled]="isDisabled">
                                Descargar Excel
                            </button>
                        </div>
                        <div class="col-md-4">
                            <h4 class="card-title mb-0">Listado de Remisiones</h4>
                            <h6 class="category mb-0">Filtra con el campo "Search records"</h6>
                            <h6 style="color: darkblue; margin-bottom: 0;">Documentos Retornados: {{temp.length}}</h6>
                            <h6 style="color: darkgreen; margin-bottom: 0;">Descargados: {{totalDownload}}</h6>
                            <h6 style="color: darkred; margin-bottom: 0;">Errores: {{totalErrors}}</h6>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="dataTables_wrapper">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div class="dataTables_length" id="datatable_length">
                                    <label>
                                        Show
                                        <select name="datatable_length" aria-controls="datatable"
                                            class="form-control form-control-sm" (change)="entriesChange($event)">
                                            <option value="10" [selected]="entries==10">10</option>
                                            <option value="25" [selected]="entries==25">25</option>
                                            <option value="50" [selected]="entries==50">50</option>
                                            <option value="-1" [selected]="entries==-1">All</option>
                                        </select>
                                        entries
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="datatable_filter" class="dataTables_filter">
                                    <label>
                                        <input type="search" class="form-control form-control-sm"
                                            placeholder="Search records" aria-controls="datatable"
                                            (keyup)="filterTable($event)" />
                                    </label>
                                </div>
                            </div>
                        </div>
                        <ngx-datatable class="bootstrap selection-cell" [columnMode]="'force'" [headerHeight]="50"
                            [footerHeight]="50" [rowHeight]="'auto'" [colWidth]="'auto'"
                            [limit]="entries != -1 ? entries : undefined" [scrollbarH]="true" [rows]="temp"
                            (activate)="onActivate($event)">
                            <ngx-datatable-column name="Correlativo" prop="shipmentInternNumber" [sortable]="true"></ngx-datatable-column>
                            <ngx-datatable-column name="Fecha" prop="shipmentDate"></ngx-datatable-column>
                            <ngx-datatable-column name="Cliente" prop="NombreCliente"></ngx-datatable-column>
                            <ngx-datatable-column name="Piloto" prop="NombrePilot"></ngx-datatable-column>
                            <ngx-datatable-column name="CDC" prop="shipmentAuthorization"></ngx-datatable-column>
                            <ngx-datatable-column name="Estado DNIT" prop="Estado"></ngx-datatable-column>
                            <ngx-datatable-column name="Resultado" [sortable]="false">
                                <ng-template ngx-datatable-cell-template let-row="row">
                                    <span *ngIf="row.downloadStatus === 'Exitoso'"
                                        style="color: green; font-weight: bold;">
                                        Exitoso
                                    </span>
                                    <span *ngIf="row.downloadStatus && row.downloadStatus !== 'Exitoso'"
                                        style="color: red; font-size: 0.78rem;" [title]="row.downloadStatus">
                                        {{ row.downloadStatus | slice:0:60 }}{{ row.downloadStatus.length > 60 ? '...' : '' }}
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column [sortable]="false" [canAutoResize]="true" [draggable]="false"
                                [resizeable]="true">
                                <ng-template ngx-datatable-header-template>
                                    Acciones
                                </ng-template>
                                <ng-template ngx-datatable-cell-template let-row="row">
                                    <a href="#" class="btn btn-round btn-success btn-icon btn-sm"
                                        (click)="searchShipment($event, row)" ngbTooltip="Descargar PDF"
                                        placement="left">
                                        <i class="now-ui-icons files_paper"></i>
                                    </a>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- FIN TABLA -->
</div>
